<template>
  <div class="flex items-center h-full">
    <span v-if="formatted" class="text-xs text-gray-600">{{ formatted }}</span>
    <span v-else class="text-xs text-gray-400">-</span>
  </div>
</template>

<script>
export default {
  name: 'Quality_LastWorkCell',
  props: ['params'],
  computed: {
    formatted() {
      const date = this.params.value;
      if (!date) return null;
      return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  }
};
</script>
